export default "__VITE_PUBLIC_ASSET__dd44acb9__"